module.exports = __webpack_public_path__ + "img/12.1ad275fa.png";